export default __webpack_public_path__ + "static/media/blog-img142.bcdebdea.jpg";